
import { filtroPorTabelaStore, mainStore } from '@/store';
import _ from 'lodash';
import { Component, Emit, Vue, Watch } from 'vue-property-decorator';
@Component
export default class FiltrosPorTabela extends Vue {
  headers = [
    {
      text: 'Coluna',
      sortable: true,
      value: 'description',
      align: 'left',
    },
  ];

  search = '';
  dialog = false;
  campos = [];
  selectedRows = [];
  loading = true;
  table = '';

  get currentUser() {
    return mainStore.userProfile!;
  }

  async salvar() {
    await this.$swal({
      title: 'Confirma a atualização das colunas?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, eu confirmo!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        await filtroPorTabelaStore.updateColumns({
          columns: this.selectedRows,
          table: this.table,
        });
        this.$emit('save');
      }
    });
  }

  @Watch('dialog')
  onChangeDialog(v) {
    if (v) {
      this.onOpen();
    } else {
      this.onClose();
    }
  }

  @Emit('open')
  onOpen() {
    return true;
  }

  @Emit('close')
  onClose() {
    return true;
  }

  move(direction: string, idx: number, el: any) {
    // this.selectedRows = _.map(this.selectedRows, (r) => {
    //   r.class = null;
    //   return r;
    // });
    const item = this.selectedRows[idx];

    this.selectedRows.splice(idx, 1);
    this.selectedRows.splice(direction === 'up' ? idx - 1 : idx + 1, 0, item);
    return this.selectedRows;
  }

  async show(table: string) {
    this.loading = true;
    this.dialog = true;
    this.table = table;
    this.selectedRows = _.orderBy(
      await filtroPorTabelaStore.getColumnsByUser({
        table: this.table,
        userId: this.currentUser.id,
      }),
      'column_position'
    );
    this.campos = await filtroPorTabelaStore.getColumns(this.table);
    this.loading = false;
  }
}
